<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer010">
<p class="basic-paragraph"><span class="charoverride5"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride5">Dedication</span></h1>
<p class="basic-paragraph"><span class="charoverride7"><br class="calibre1"/></span></p>
<p class="basic-paragraph"><span class="charoverride7"><br class="calibre1"/></span></p>
<p class="basic-paragraph"><span class="charoverride7">This one’s for Max, who could navigate</span></p>
<p class="basic-paragraph"><span class="charoverride7">the pista della morte with his eyes closed.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?0db19caa